import { render, staticRenderFns } from "./afterSaleManageAffirm.vue?vue&type=template&id=4a4566d7&scoped=true"
import script from "./afterSaleManageAffirm.vue?vue&type=script&lang=js"
export * from "./afterSaleManageAffirm.vue?vue&type=script&lang=js"
import style0 from "./afterSaleManageAffirm.vue?vue&type=style&index=0&id=4a4566d7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4566d7",
  null
  
)

export default component.exports